import './App.css';
import HashingVisualizer from './HashingVisualizer/HashingVisualizer';

function App() {
  return (
    <div className="App">
      <HashingVisualizer></HashingVisualizer>
    </div>
  );
}

export default App;
